{
  "rwg-cancel-request-page": {
    "buttons": {
      "cancel": "Zrušit",
      "submit": "Odeslat",
      "to-home-page": "Na domovskou stránku"
    },
    "meta": {
      "title": "Beauty Pro - Žádost o deaktivaci integrace Google",
      "description": "Vyplňte následující formulář a požádejte o deaktivaci naší integrace se službou Google na mapě Google."
    },
    "text": {
      "title": "Žádost o deaktivaci integrace Google",
      "subtitle-salon-info": "Kde je váš salon?",
      "subtitle-owner-info": "Jak se na vás můžeme obrátit?",
      "email": "Váš e-mail",
      "full-name": "Vaše celé jméno",
      "language": "Váš preferovaný jazyk pro komunikaci",
      "request-sent-success": "Váš požadavek byl úspěšně odeslán!",
      "request-confirmation-sent-to-your-email": "Naše potvrzení vám bude zasláno na váš e-mail. Zkontrolujte si prosím také složku s nevyžádanou poštou!",
      "salon-address": "Adresa vašeho salonu",
      "salon-name": "Název vašeho salonu",
      "we-will-contact-soon": "Náš tým vám ochotně pomůže a brzy se s vámi spojíme, abychom vyřešili váš požadavek."
    }
  }
}
